import { useEffect, useState } from 'react';

import Sidebar from '../components/Sidebar';

import { supabase } from '../supabase/config';

import './FAQ.css';

const FAQ = () => {

    const [faq, setFaq] = useState([]);


    const getFaq = async () => {

        const { data, error } = await supabase
        .from('faq')
        .select('*');

        if(data){
            setFaq(data);
        }

        if(error){
            console.log(error);
        }
    }


    useEffect(() => {

        getFaq();

    }, []);


    return (

        <div className="faq-page">

            <Sidebar />

            <div className="faq-content">

                <h1>FAQ Management</h1>

                <p className="faq-text">
                    Manage frequently asked questions for the website.
                </p>


                <div className="faq-container">

                    {faq.map((item) => (

                        <div
                            className="faq-card"
                            key={item.id}
                        >

                            <h2>{item.question}</h2>

                            <p>{item.answer}</p>

                        </div>

                    ))}

                </div>

            </div>

        </div>

    );
}

export default FAQ;